import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { ContractAlertItem } from '../admin-dashboard.models';

@Component({
  selector: 'app-contract-alerts',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzButtonModule,
    NzCardModule,
    NzEmptyModule,
    NzListModule,
    NzSkeletonModule,
    NzTagModule,
  ],
  templateUrl: './contract-alerts.component.html',
  styleUrl: './contract-alerts.component.less',
})
export class ContractAlertsComponent {
  @Input() items: ContractAlertItem[] = [];
  @Input() loading = false;
  @Output() openCompany = new EventEmitter<string>();

  constructor(private readonly translate: TranslateService) {}

  statusColor(status: string): string {
    switch (status) {
      case 'critical':
      case 'overdue':
        return 'red';
      case 'action_required':
        return 'volcano';
      case 'warning':
        return 'gold';
      default:
        return 'default';
    }
  }

  alertText(item: ContractAlertItem): string {
    return this.translate.instant(item.descriptionKey, item.params || {});
  }

  planText(plan: string): string {
    return this.translate.instant(`PLAN.${String(plan || 'free').toUpperCase()}`);
  }

  formatDate(value: string | null | undefined): string {
    if (!value) {
      return '—';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '—';
    }
    const locale = (this.translate.currentLang || 'en').toLowerCase().startsWith('de') ? 'de-DE' : 'en';
    return new Intl.DateTimeFormat(locale, {
      day: locale === 'de-DE' ? '2-digit' : 'numeric',
      month: locale === 'de-DE' ? '2-digit' : 'short',
      year: 'numeric',
    }).format(date);
  }
}
